import React, {PureComponent} from "react";
import {BenefitEntity, ProgressionLevelEntity} from "../../data/entities/ProgressionLevelEntity";
import giftIcon from "../../resources/icons/icon-gift.svg";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import {FormattedMessage, FormattedPlural} from "react-intl";
import {AdobeAnalyticsContext} from "../../context/AdobeAnalyticsContext";
import classNames from "classnames";


interface Props {
    progressionLevel: ProgressionLevelEntity;
    previousProgressionLevel: ProgressionLevelEntity|null;
    index: number;
    totalMonths: number;
    consecutiveActiveMonths: number;
}

interface State {
    progressBarStyle: object;
    currentProgressStyle: object;
}

const TRANSITION_DURATION: number = 0.6;

export default class ProgressionLevelMilestone extends PureComponent<Props, State> {
    static contextType = AdobeAnalyticsContext;
    context!: React.ContextType<typeof AdobeAnalyticsContext>;

    constructor(props: Props) {

        super(props);

        this.state = {
            progressBarStyle: {
                transition: `all ${(TRANSITION_DURATION * this.props.progressionLevel.userProgress / 100)}s linear ${this.props.index * TRANSITION_DURATION}s`
            },
            currentProgressStyle: {}
        };
    }

    getMonthsBars(): JSX.Element[] | null {
        let monthsBars: JSX.Element[] = [];

        let {consecutiveActiveMonths, previousProgressionLevel, progressionLevel} = this.props;

        if(previousProgressionLevel === null) {
            return null;
        }

        let monthsDiff = progressionLevel.ruleSubscriptionMonths - previousProgressionLevel.ruleSubscriptionMonths;

        for (let i = 0; i < monthsDiff; i++) {
            let monthBarClassnames = classNames({
                "progressBarBg": true,
                "complete": consecutiveActiveMonths >= (previousProgressionLevel.ruleSubscriptionMonths+i+1),
            });

            monthsBars.push(
                <div className={monthBarClassnames} key={i}>
                </div>
            );
        }
        return monthsBars;
    }

    calculateSeparatorBarWidth() {
        let {progressionLevel, previousProgressionLevel, totalMonths} = this.props;
        if(previousProgressionLevel === null) {
            return 0;
        }
        return 80 / totalMonths * (progressionLevel.ruleSubscriptionMonths - previousProgressionLevel.ruleSubscriptionMonths);
    }

    getBenefitIcon(benefit: BenefitEntity): JSX.Element | null {
        let icon = null;

        switch (benefit.typeId) {
            case 1:
            default:
                icon = giftIcon;
                break;
        }

        return (icon === null) ? null : <img src={icon} className={"benefitIcon"} alt=""/>;
    }

    componentDidMount(): void {
        this.setState({
            progressBarStyle: {
                ...this.state.progressBarStyle,
                width: `${this.props.progressionLevel.userProgress}%`,
            },
            currentProgressStyle: {
                opacity: 1,
                transitionDelay: `${this.props.index * TRANSITION_DURATION * 1.2}s`
            }
        });
    }

    render(): JSX.Element {
        const {progressionLevel, index} = this.props;

        let rewardBenefit = progressionLevel.benefits.find(benefit => benefit.typeId === 1);

        return (
            <>
                {
                    index > 0 &&
                    <div
                        className="progressBarSeparator"
                        style={{
                            width: `${this.calculateSeparatorBarWidth()}%`,
                        }}
                    >
                        {this.getMonthsBars()}
                    </div>
                }
                <div
                    data-tip
                    data-for={`progression-level-${index}`}
                    className="milestoneIconHolder"
                    onMouseOver={() => this.trackLevelInteraction(progressionLevel)}
                >
                    <img
                        src={progressionLevel.image}
                        alt={progressionLevel.name}
                        className="progressionLevelMilestoneIcon"
                    />
                    <div className="progressionLevelMilestoneTooltip">
                        <div className="content">
                            <ul className="progressionLevelSummary">
                                <li>{progressionLevel.name}</li>
                                <li>
                                    {
                                        rewardBenefit &&
                                        <React.Fragment>
                                            {this.getBenefitIcon(rewardBenefit)} x <span className="highlight">{rewardBenefit.value}</span>
                                        </React.Fragment>
                                    }

                                </li>
                                <li>
                                    {
                                        progressionLevel.monthsRemaining === 0 &&
                                        <span className="highlight progressionLevelAchieved">
                                                <FontAwesomeIcon icon={faCheck}/>
                                            </span>
                                    }
                                    {
                                        progressionLevel.monthsRemaining > 0 &&
                                        <React.Fragment>
                                            <span className="highlight">{progressionLevel.monthsRemaining}</span> <FormattedPlural
                                            one={<FormattedMessage id="general.date.month_remaining" />}
                                            other={<FormattedMessage id="general.date.months_remaining" />}
                                            value={progressionLevel.monthsRemaining}
                                        />
                                        </React.Fragment>
                                    }
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    trackLevelInteraction = (progressionLevel: ProgressionLevelEntity) => {
        this.context.track("clickevent", {location: "progression", category: "interaction", action: `status milestones : ${progressionLevel.name}`});
    };
}